
// PRODUCT CARDS
function mmProductCardCTA(CTA, validatedText) {
  const productCard = CTA.closest('.mm-product-card');
  const variantId = parseInt(CTA.dataset.variantId);

  // If second click (if card classes contains class) - add to cart, change CTA text
  if (productCard.classList.contains('mm-activated') || !productCard.classList.contains('mm-product-card-offstage'))  {
    mmAddProductToCart(variantId, { openCart: true })
    changeText(CTA, validatedText);    
  }
  
  // If first click - add class to product card
  if (!productCard.classList.contains('mm-activated') && productCard.classList.contains('mm-product-card-offstage')) {
    productCard.classList.add('mm-activated');
  }  

  // If mouseleave - remove class
  productCard.addEventListener('mouseleave', function() {
    productCard.classList.remove('mm-activated');    
  });

  // If touch outside product card - remove class
  document.addEventListener('click', function(event) {
      if (!productCard.contains(event.target)) {
        productCard.classList.remove('mm-activated'); 
      }
  });

  // If slide - remove class
  document.addEventListener('scroll', function(event) {
      if (!productCard.contains(event.target)) {
        productCard.classList.remove('mm-activated'); 
      }
  });

  document.addEventListener('touchstart', function(event) {
      if (!productCard.contains(event.target)) {
        productCard.classList.remove('mm-activated'); 
      }
  });
}